import { withInstall } from '@antdv/utils';
import ASpin from './src/Spin';

export const Spin = withInstall(ASpin);

export default Spin;

export * from './src/interface';
export * from './src/props';
